import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/utils/rem'
import { CdnServerAddress } from "@/common/getServerAddress.js"

router.beforeEach((to, from, next) => {
  if (to?.meta?.title) {
    document.title = to?.meta?.title
  }
  if (!router.getMatchedComponents(to).length) {
    location.href = "/";
  } else {
    next();
  }
})

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.prototype.$CdnServerAddress = CdnServerAddress

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
